<script>
import VueSlider from "vue-3-slider-component";
import { ref } from "vue";
export default {
  name: "RangeUI",
  components: {
    VueSlider,
  },
  props: {
    values: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      priceRange: ref([this.values.min, this.values.max]),
      dotStyle: {
        backgroundColor: "black",
        border: "2px solid black",
      },
      railStyle: {
        backgroundColor: "#D9D9D9",
        height: "2px",
      },
      processStyle: {
        backgroundColor: "#D9D9D9",
        height: "2px",
      },
      dotOptions: [
        {
          style: {
            backgroundColor: "black",
            border: "2px solid black",
            width: "18px",
            height: "18px",
            borderRadius: "50%",
          },
        },
        {
          style: {
            backgroundColor: "black",
            border: "2px solid black",
            width: "18px",
            height: "18px",
            borderRadius: "50%",
          },
        },
        {
          style: {
            backgroundColor: "black",
            border: "2px solid black",
            width: "18px",
            height: "18px",
            borderRadius: "50%",
          },
        },
        { tooltip: false }, // Первый бегунок
        { tooltip: false }, // Второй бегунок
      ],
    };
  },
};
</script>

<template>
  <VueSlider
  class="vueSliderRange"
    v-model="priceRange"
    :dot-style="dotStyle"
    :rail-style="railStyle"
    :process-style="processStyle"
    :dot-options="dotOptions"
    :dot-tooltips="false"
  />
</template>

<style>
.vueSliderRange{
    width: 377px;
}
</style>
